import styled, { css } from 'styled-components';

import {
    ModalDialog,
    spaceMixin,
    token,
    mediaMixin,
} from '@zillow/constellation';

const contentMaxWidth = '550px';
const contentMaxHeight = '400px';
const minHeaderHeight = '56px';

const flexMixin = () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const maxWidthAndCenterMixin = () => css`
    max-width: ${contentMaxWidth};
    margin: 0 auto;
`;

export const StyledModalDialog = styled(ModalDialog)`
    && [class^="DialogHeader"] {
        min-height: ${minHeaderHeight};
    }

    && [class^="CloseButton"] {
        ${({ hideCloseButton }) => hideCloseButton && 'display: none;'}
    }

    && [class^="DialogBody"] {
        padding-left: ${props => props.isFluid && 0};
        padding-right: ${props => props.isFluid && 0};
        padding-top: ${props => props.isFluid && 0};

        overflow-x: hidden;

        /* when no footer prop is passed */
        ${props => !props.footer && css`
            /* remove extra spacing content */
            &::after {
                content: none;
            }
        `}
    }
`;

export const StyledModalSection = styled.div`
    ${maxWidthAndCenterMixin}
`;

export const StyledDialogBodyContainer = styled.div`
    ${maxWidthAndCenterMixin}
`;

/**
 * Use only when footer prop is NOT passed to ModalContainer
 * We need to create our own footer and handle CTA events

 ex:
 <StyledMDContainer>
    <StyledMDContentContainer>
        <StyledMDContent />
    </StyledMDContentContainer>

    <StyledMDActionsContainer />
 </StyledMDContainer>

 */
export const StyledMDContainer = styled.div`
    ${flexMixin}
`;

export const StyledMDContentContainer = styled.div`
    ${flexMixin}

    margin: ${spaceMixin('sm')} 0;
    padding: 0 ${spaceMixin('sm')};
    width: 100%;
    max-height: ${contentMaxHeight};
    overflow-y: auto;
`;

export const StyledMDContent = styled.div`
    max-width: ${contentMaxWidth};
    ${({ fullWidth }) => fullWidth && 'width: 100%'}
`;

/*
 * when using a custom footer
 * pass isFluid = true to ModalActions.showModal
*/
export const StyledMDActionsContainer = styled.div`
    padding: ${spaceMixin('sm')};
    width: 100%;
    border-top: 1px solid ${token('colors.gray300')};
    position: absolute;
    bottom: 0;

    ${mediaMixin(
        'lg',
        css`
            position: inherit;
        `
    )}
`;
